// src/components/Icon.jsx
//
// The one place the app's icons are chosen. Replaces the emoji that used to be
// scattered through labels, buttons and headings (they rendered differently on
// every OS, and read as childish next to a professional accounting UI).
//
// Usage: <Icon name="check" />  — inline, sized to the surrounding text
// (1em-based, so it scales with the parent's fontSize exactly like an emoji
// did), coloured by the surrounding text colour (currentColor), vertically
// aligned to the text baseline. Pass `style={{ color: T.gn }}` etc. to tint it,
// or `size` to override.
//
// To restyle the icon set later (a different stroke weight, a different
// library), change this file only.
import {
  Check, CircleCheck, TriangleAlert, X, OctagonX, Flag, Pencil, Mail, PenLine, Info,
  Download, Menu, Hourglass, ClipboardList, CalendarDays, CalendarX, Sparkles, Bell,
  Megaphone, WifiOff, RefreshCw, Building2, FolderOpen, BarChart3, Lock, CreditCard,
  MapPin, Paperclip, Receipt, User, Users, Landmark, Archive, Search, Lightbulb,
  FilePenLine, Eye, Printer, FileText, Banknote, MessageCircle, Plug, Circle,
} from 'lucide-react'

export const ICONS = {
  check: Check, checkCircle: CircleCheck, alert: TriangleAlert, x: X, block: OctagonX,
  flag: Flag, pencil: Pencil, mail: Mail, sign: PenLine, info: Info,
  download: Download, menu: Menu, hourglass: Hourglass, log: ClipboardList,
  calendar: CalendarDays, noCalendar: CalendarX, ai: Sparkles, bell: Bell,
  megaphone: Megaphone, offline: WifiOff, refresh: RefreshCw, building: Building2,
  folder: FolderOpen, chart: BarChart3, lock: Lock, card: CreditCard,
  pin: MapPin, attach: Paperclip, receipt: Receipt, user: User, users: Users,
  bank: Landmark, archive: Archive, search: Search, tip: Lightbulb,
  note: FilePenLine, eye: Eye, print: Printer, file: FileText, money: Banknote,
  chat: MessageCircle, plug: Plug, circle: Circle,
}

export default function Icon({ name, size = '1.1em', strokeWidth = 2, style, ...rest }) {
  const Cmp = ICONS[name]
  if (!Cmp) return null
  return (
    <Cmp
      size={size}
      strokeWidth={strokeWidth}
      aria-hidden="true"
      style={{ display: 'inline-block', verticalAlign: '-0.2em', flexShrink: 0, ...style }}
      {...rest}
    />
  )
}

// Small filled status dot (replaces the coloured-circle emoji). `color` is any
// CSS colour, typically a theme token.
export function Dot({ color = 'currentColor', size = '0.55em', style }) {
  return (
    <span
      aria-hidden="true"
      style={{
        display: 'inline-block', width: size, height: size, borderRadius: '50%',
        background: color, verticalAlign: '0.05em', flexShrink: 0, ...style,
      }}
    />
  )
}
